/* ============
 * Actions for the user module
 * ============
 *
 * The actions that are available on the
 * user module.
 */
import axios from 'axios'
import environment from '@/utils/environment'
import sessionActions from './session.actions'

export default {
  // login, ensureSession, checkJWT, tmpCheckJWT e inactiveJwtLogout contra CR Auth
  ...sessionActions,
  signIn ({ commit, dispatch }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.post(api + 'usuarios/ingresos', item)
        .then(res => {
          if (res) {
            // WHEN USER REGISTER FOR FIRST TIME, AVOID SAVE DATA IN VUEX
            commit('setJWT', res.data.jwtToken)
            commit('setCodeUser', res.data.codigoUsuario)
            commit('setFunctions', res.data.funcionalidades)
            if (item.saveData) {
              commit('setUser', res)
            }
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  signInV2 ({ commit, dispatch }, item) {
    let apiV2 = process.env.ENVIRONMENT === 'dev' ? process.env.API_URL : process.env.API_URL // _V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'usuarios/ingresos', item)
        .then(res => {
          if (res) {
            // WHEN USER REGISTER FOR FIRST TIME, AVOID SAVE DATA IN VUEX
            commit('setJWT', res.data.jwtToken)
            commit('setCodeUser', res.data.codigoUsuario)
            commit('setFunctions', res.data.funcionalidades)
            if (item.saveData) {
              commit('setUser', res)
            }
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  signUpVersion2 ({ state, commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'usuarios/registros', item)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  userExists ({ state, commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('usuarios/' + item.tipoDocumento + '/existe/' + item.numeroDocumento)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  secretQuestions ({ commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'usuarios/preguntas', item)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  lockAccount ({ commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'usuarios/lock', item)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  validateCecretQuestions ({ commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'usuarios/respuestas', item)
        .then(res => {
          // CUANDO EL JWT ES RETORNADO CORRECTAMENTE
          if (res.data.jwt) {
            commit('setJWT', res.data.jwt)
          }
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updatePassword ({ commit, dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post('users/passwords/updates', item)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  recoveryPasswordOptions ({ state }, item) {
    var url = 'usuarios/claves/recuperaciones/tipoDocumentos/' + item.tipoDocumento + '/numeroDocumentos/' + item.numeroDocumento
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getUserInfo ({ state, commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('users/details/' + item.codigoUsuario)
        .then(res => {
          commit('setBasicInfo', res)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getIP ({ state, commit }) {
    let api = process.env.GET_IP
    return new Promise((resolve, reject) => {
      axios.get(api)
        .then(res => {
          commit('setIP', res.data.clientIp)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  doResendCode ({ commit, dispatch }, item) {
    return true
  },
  getPolizas ({ commit, dispatch }, item) {
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // axios.get('/polizas/' + item.codigoUsuario)
        axios.get('policies')
          .then(res => {
            if (item.isCalled) {
              commit('setExtra', res.data.extra)
              return;
            }

            let policies = res.data.polizas
            commit('setPolizas', policies)
            commit('setFunctions', res.data.funcionalidades)
            commit('setExtra', res.data.extra)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getPolizasVidaVehicular ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // axios.get('/polizas/' + item.codigoUsuario)
        // axios.get('http://localhost:8003/api-zonasegura/v1/polizas/vida-vehicular')
        axios.get('policies/life-vehicle')
          .then(res => {
            let policies = res.data.polizas
            commit('setPolizasVidaVehicular', policies)
            commit('setFunctions', res.data.funcionalidades)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getCupones ({ dispatch }, numeroPoliza) {
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // numeroPoliza = '07800083035'
        axios.get(process.env.API_URL + 'policies/coupons/' + numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  validateCupones ({ dispatch }, numeroPoliza) {
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // numeroPoliza = '07800083035'
        axios.get(process.env.API_URL + 'policies/coupons/validations/' + numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getTypeOfClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/polizas/tipo-cliente/' + item.tipoDocumento + '/numero/' + item.numeroDocumento)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSiniestros ({ commit, dispatch }, item) {
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get('policies/claims/' + item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getBenefits ({ commit, dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    var url = apiV2 + 'lines/life/beneficiaries/'
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(url + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getElectronicDocuments ({ commit, dispatch }, item) {
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get('polizas/documentos/electronicos/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getPDFPolizaElectronica ({ state }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.get('policies/processes/' + item.codProceso + '/electronic-documents/' + item.numPoliza)
        .then(res => {
          if (item.makeDownload) {
            if (res.status !== 204) {
              var link = document.createElement('a')
              link.href = api + 'policies/processes/' + item.codProceso + '/electronic-documents/' + item.numPoliza
              link.target = '_blank'
              link.download = 'POLIZA_' + item.numeroPoliza
              link.click()
            }
          }
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPDFPolizaVida ({ state }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.post(api + 'lines/life/account-statements', item)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = res.data.url
            link.download = res.data.nombreArchivo

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            resolve(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getPDFPolizaVidaV2 ({ state }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.post(api + 'lines/life/account-statements/v2', item)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = api + 'lines/life/downloads/' + res.data.streamArchivo.split('.')[0]
            link.download = res.data.streamArchivo
            link.target = '_blank'
            link.click()
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getPDFTablaValoresGarantizados ({ state }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.get(api + 'lines/life/value-tables/' + item.numeroPoliza)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = api + 'lines/annuities/downloads/' + res.data.streamArchivo.split('.')[0]
            link.download = res.data.streamArchivo
            link.target = '_blank'
            link.click()
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getPDFTablaRescates ({ state }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.get(api + 'lines/life/refund-tables/' + item.numeroPoliza)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = api + 'lines/annuities/downloads/' + res.data.streamArchivo.split('.')[0]
            link.download = res.data.streamArchivo
            link.target = '_blank'
            link.click()
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getPDFPolizaRentaV2 ({ state }, item) {
    let api = process.env.API_URL
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.get(apiV2 + 'lines/annuities/policies/' + item.tipo + '/' + item.numeroPoliza)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = api + 'lines/annuities/downloads/' + res.data.streamArchivo.split('.')[0]
            link.download = res.data.streamArchivo
            link.target = '_blank'
            link.click()
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getPDFConstanciaJubilacion ({ state }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.post(api + 'lines/annuities/retirement-certificates', item)
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = api + 'lines/annuities/downloads/' + res.data.nombreArchivo.split('.')[0]
            link.download = res.data.nombreArchivo
            link.target = '_blank'
            link.click()
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getPDFHistoricoPago ({ state }, item) {
    /* item variable must have the URL to PDF */
    let api = process.env.API_URL
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.get(apiV2 + 'lines/annuities/payment-files/' + item.codigoPago.toString() + '/' + item.tipoProducto + (item.numeroPoliza ? '/' + item.numeroPoliza : ''))
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            var link = document.createElement('a')
            link.href = api + 'lines/annuities/downloads/' + res.data.streamArchivo.split('.')[0]
            link.download = res.data.nombreArchivo
            link.target = '_blank'
            link.click()
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(err => reject(err))
    })
  },
  getHistoricoPagos ({ commit, dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/payment-history/' + item.numeroPoliza + '/' + item.codigoUsuario)
          .then(res => {
            // var resGrouped = _.groupBy(res.data.pagos, 'anioPago')
            commit('setHistoryPayments', res.data.pagos)
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  getInformacionPrestamo ({ commit, dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/loan-parameters/' + item.poliza + '/' + item.vista)
          .then(res => {
            if (res.data) {
              commit('setHaveLoanRequested', false)
            } else {
              commit('setHaveLoanRequested', true)
            }
            resolve(res)
          })
          .catch(err => { resolve(err) })
      })
    })
  },
  getMontosPrestamoVida ({ dispatch }, { numeroPoliza }) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/life/loans/amounts/' + numeroPoliza)
          .then(res => { resolve(res) })
          .catch(err => { reject(err) })
      })
    })
  },
  getPrestamosVidaDisponibilidad ({ dispatch, commit }) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'life/loans/policies')
          .then(res => {
            if (res.data && res.data.codigoRespuesta === '01') {
              commit('setPrestamosVidaDisponibilidad', res.data)
            }
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  registrarSolicitudPrestamoVida ({ dispatch }, payload) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(apiV2 + 'lines/life/loans/applications', payload)
          .then(res => { resolve(res) })
          .catch(err => { reject(err) })
      })
    })
  },
  getPrestamosActivos ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/loans/' + item.tipoDocumento + '/' + item.numeroDocumento)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  getInformacionPrepagos ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/prepayment-parameters/' + item.numeroPoliza + '/' + item.codigoPrestamo)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  // METHOD that pass from middleware ZP Backend to ADMWR - for Pretamos RPP
  saveCronogramaPrestamo ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(apiV2 + 'lines/annuities/schedules', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  sendCronogramaPago ({ dispatch, commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(apiV2 + 'lines/annuities/schedule-deliveries', item)
          .then(res => {
            commit('setHaveLoanRequested', true)
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  sendCronogramaPrepago ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(apiV2 + 'lines/annuities/prepayment-schedule-deliveries', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  downloadComprobanteLegacy ({ dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'paperless/download/' + item.tipoDoc + '/' + item.folio)
          .then(res => {
            if (res.data !== '') {
              var link = document.createElement('a')
              link.href = res.data
              link.target = '_blank'
              link.click()
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch(err => { reject(err) })
      })
    })
  },
  sendDataToRequirements ({ dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      axios.post(api + 'requirement/makerequire', item)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  verifyAvailablePrepago ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/prepayment-verifications/' + item.codigoPrestamo)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  getCronogramaPago ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/payment-schedules/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  getEstadoPrestamo ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/loan-statuses/' + item.codigoUsuario)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  setEstadoPrestamo ({ dispatch, commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/annuities/loan-status-updates/' + item.codigoUsuario + '/' + item.flag)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  setTrackingClient ({ dispatch, commit }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(apiV2 + 'lines/annuities/tracking-events', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  sendCodigoPrestamo ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'users/loans/verification-codes/' + item.codigoUsuario + '/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  sendRemarketing ({ dispatch }, item) {
    let api = process.env.API_REMARKETING
    return new Promise((resolve, reject) => {
      axios.post(api + 'sesiones/activaciones', item)
        .then(res => {
          resolve(res)
        })
        .catch(err => { reject(err) })
    })
  },
  validateCodigoPrestamo ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'users/loans/code-validations/' + item.codigoUsuario + '/' + item.codigo)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  getComprobantes ({ dispatch }, item) {
    let apiComprobantes = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiComprobantes + 'payments/receipts/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  downloadComprobante ({ dispatch }, item) {
    let apiComprobantes = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(apiComprobantes + 'payments/receipts/downloads', item)
          .then((res) => {
            if (res.data.codigoRespuesta === '01') {
              var link = document.createElement('a')
              link.href = res.data.urlPDF
              link.download = res.data.nombreArchivo

              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch(err => { reject(err) })
      })
    })
  },
  removeSession ({ state, commit }) {
    localStorage.removeItem('jwt')
    commit('clear')
  },
  sendSMSValidationPhone ({ commit, dispatch }, data) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'users/requests/verification-codes', data)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  validateCodeValidationPhone ({ commit, dispatch }, data) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'users/requests/code-validations', data)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  checkIfPolicyHasPendingOkActDatos ({dispatch}, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      axios.get(api + 'requirement/all?numberDoc=' + item.numDoc + '&type=Actualización de datos&state=PENDIENTE')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCustomerData ({commit, dispatch}, data) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'payment-method-changes/customer-policies/' + data.dni)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getSessionKey ({ commit, dispatch }, data) {
    // Ruta del BFF (portal-api) publicada en Apigee: se toma la misma base que el centro de ayuda y la contraseña.
    const api = environment.getPortalApiUrl()
    // La apiKey del comercio ya no pasa por el navegador: el BFF la resuelve a partir de `numeroPoliza` (la póliza
    // debe ser del titular de la sesión). Se descarta aquí aunque el llamador la incluya.
    const { apiKey: _apiKey, ...sesion } = data
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'payments/sessions', sesion)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js